<template>
  <div class="home">
    <home-hero />
    <home-calculator />
  </div>
</template>

<style lang="scss">
.home {
  width: 100%;
}
</style>

<script>
import HomeHero from '@/components/Home/Hero.vue';
import HomeCalculator from '@/components/Home/Calculator.vue';

export default {
  mounted() {
    if (this.$route.hash == '#calculadora') {
      window.scrollBy({
        top: window.innerHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  },
  components: {
    'home-hero': HomeHero,
    'home-calculator': HomeCalculator,
  },
};
</script>
